export enum AdditionalReferenceStatus {
  ACTIVE = "active",
  INACTIVE = "inactive",
}
